<template>
	<div id="articleCard" class="articleCard">
    <span class="imgWrap" v-if="articleImage != null">
      <img :src="articleImage" class="backgroundBlur" /><img :src="articleImage" class="img-fluid cardImage"/>
    </span>
		<div class="cardHeader">
			<span class="profile" :style="bgImage"></span>
			<h3>{{ cardData.json_object.title }} <small>{{ whenDate }} - {{ cardData.json_object.author }}</small></h3>
		</div>
    	<p>{{ cardData.json_object.description }}</p>
    	<div class="cardActions">
    		<button @click="openArticle()" class="btn btn-default btn-block">Read more &rarr;</button>
    	</div>
        <!-- <div class="moreOfThis">
            <p>See more of this?</p>
            <a href="#">Yes</a>
            <a href="#">No</a>
        </div> -->
    </div>
</template>

<script>
    import moment from 'moment'

    export default {
      name: 'article-card',
      props: {
        cardData: {
          type: Object,
          default: null
        }
      },
      computed: {
        bgImage () {
          return 'background-image: url(' + this.cardData.json_object.urlToImage + ');'
        },
        articleImage () {
          return this.cardData.json_object.urlToImage
        },
        whenDate () {
          return moment(this.cardData.created_at).format('DD MMM YYYY')
        }
      },
      mounted: function () {

      },
      methods: {
        openArticle () {
          window.open(this.cardData.json_object.url, '_blank')
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cards/Article.vue